<script>
  import { External, M } from '../../external';
  import { onMount } from 'svelte';
  import { addNewCircle } from '../service/LmsUIService';

  let introVideoMarkup = '';
  onMount(() => {
    if (External.Website.onboarding?.communityDashboard) {
      introVideoMarkup = External.CPanel.getEmbedVideo(External.Website.onboarding.communityDashboard);
    }
  });
</script>

<div class="col20 f-left getting-started-layout flex flex-col align-center justify-center">
  <h4 class="col20 f-left t-center"><span class="f-none inline-block">{M.GETTING_STARTED}</span></h4>
  <h1 class="col14 f-left mt-10 mb-15 t-center">{M.START_BUILDING_CIRCLES}</h1>
  <span class="col10 f-left paragraph-text mb-25 t-center">{M.GETTING_STARTED_CIRCLES_DESC}</span>
  <div class="col20 f-left t-center"><a on:click={addNewCircle} class="blue middle-button with-icon f-none inline-block">{M.CREATE_YOUR_FIRST_CIRCLE}</a></div>
  <div class="col12 f-left justify-center align-center flex mt-25">
    <div class="col20 f-left">
      {@html introVideoMarkup}
    </div>
  </div>
<!--
  <div class="col20 f-left flex align-center justify-center mt-55">
    <div class="big-icon-wrapper">
      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#5f6368"><path d="M333.85-343.08q25.3 0 42.65-17.34 17.35-17.35 17.35-42.66 0-25.3-17.35-42.65-17.35-17.35-42.65-17.35-25.31 0-42.66 17.35-17.34 17.35-17.34 42.65 0 25.31 17.34 42.66 17.35 17.34 42.66 17.34Zm292.3 0q25.31 0 42.66-17.34 17.34-17.35 17.34-42.66 0-25.3-17.34-42.65-17.35-17.35-42.66-17.35-25.3 0-42.65 17.35-17.35 17.35-17.35 42.65 0 25.31 17.35 42.66 17.35 17.34 42.65 17.34ZM480-575.38q25.31 0 42.65-17.35Q540-610.08 540-635.38q0-25.31-17.35-42.66-17.34-17.34-42.65-17.34t-42.65 17.34Q420-660.69 420-635.38q0 25.3 17.35 42.65 17.34 17.35 42.65 17.35Zm.13 455.38q-74.67 0-140.41-28.34-65.73-28.34-114.36-76.92-48.63-48.58-76.99-114.26Q120-405.19 120-479.87q0-74.67 28.34-140.41 28.34-65.73 76.92-114.36 48.58-48.63 114.26-76.99Q405.19-840 479.87-840q74.67 0 140.41 28.34 65.73 28.34 114.36 76.92 48.63 48.58 76.99 114.26Q840-554.81 840-480.13q0 74.67-28.34 140.41-28.34 65.73-76.92 114.36-48.58 48.63-114.26 76.99Q554.81-120 480.13-120Zm-.13-40q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
    </div>
  </div>
-->
</div>
